import MomentTimezone from 'moment-timezone'

export default {
  methods: {
    mediaTypeOptions () {
      const options = {
        all: { value: 'all', label: this.$t('label.all') },
        image: { value: 'img', label: this.$t('label.image', 2) },
        video: { value: 'video', label: this.$t('label.video') },
        project: { value: 'project', label: this.$t('label.project', 2) }
      }

      return options
    },
    customTimeZone () {
      const timeZone = []

      for (const i in MomentTimezone.tz.names()) {
        const tz = MomentTimezone.tz.names()[i]
        const tzSplitNames = MomentTimezone.tz.names()[i].split('/')
        let customTzName = ''

        if (tzSplitNames.length === 1) {
          customTzName = `${tzSplitNames[0]}`
        } else if (tzSplitNames.length === 2) {
          customTzName = `${tzSplitNames[1]} - ${tzSplitNames[0]}`
        } else if (tzSplitNames.length === 3) {
          customTzName = `${tzSplitNames[1]} ${tzSplitNames[2]} - ${tzSplitNames[0]}`
        }

        timeZone.push({ value: tz, label: customTzName })
      }

      timeZone.push({ value: 'Europe/Zurich', label: 'Geneva - Europe' })
      timeZone.push({ value: 'Europe/Zurich', label: 'Bern - Europe' })

      return timeZone
    },
    languageCommonOptions () {
      return [
        { code: 'ar', name: 'Arabic', icon: 'arabic', label: 'Arabic / عربي' },
        { code: 'it', name: 'Italian ', icon: 'italian', label: 'Italian / Italiano' },
        { code: 'nl', name: 'Dutch', icon: 'dutch', label: 'Dutch / Nederlands' },
        { code: 'ja', name: 'Japanese', icon: 'japanese', label: 'Japanese / 日本語' },
        { code: 'en', name: 'English', icon: 'uk', label: 'English' },
        { code: 'ru', name: 'Russian', icon: 'russian', label: 'Russian / Русский' },
        { code: 'fr', name: 'French', icon: 'french', label: 'French / Français' },
        { code: 'es', name: 'Spanish', icon: 'spanish', label: 'Spanish / Español' },
        { code: 'de', name: 'German', icon: 'german', label: 'German / Deutsch' }
      ]
    }
  }
}
